/**
 * Runs callback once when an element matching selector exists in the DOM.
 * jQuery-free replacement for helpers/jquery/onElementExistRunOnce.
 *
 * @param {string} selector  - CSS selector
 * @param {function} callback - callback function
 */
export const onElementExistRunOnce = (selector, callback) => {
  const run = () => {
    if (document.querySelector(selector)) {
      callback();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
};
